/**
 * ---------------------------------------------------------------------------------------------------------------------
 * Các keys lưu trữ trong storage trình duyệt --------------------------------------------------------------------------
 * ---------------------------------------------------------------------------------------------------------------------
 *
 * @author admin
 * */

export const STORAGE_KEY = {
  langDefault: 'nhanhLangDefault',

  businesses: 'businesses',
  accessToken: 'nhanhAccessToken',
  userData: 'nhanhUserData',
  profileUI: 'nhanhProfileUI',
  BUSINESS_CURRENT: 'businessCurrent',
  usr: 'usr',
  localSettings: 'localSettings',

  // Toàn bộ cấu hình giao diện Ads portal gom trong 1 object (menu, sidebar, độ rộng, dark mode, màu)
  adsProfileUi: 'adsProfileUi',

  // Phiên đăng nhập Ads portal — chỉ AdsSessionService đọc/ghi (BE file 02 mục 1.5)
  adsAccessToken: 'adsAccessToken',       // JWT access token, gửi qua Authorization: Bearer
  adsUser: 'adsUser',                     // {posUserId, fullName} lấy lúc đăng nhập
  adsBusinesses: 'adsBusinesses',         // DN user được dùng trong Ads, kèm businessRole (quyền lấy qua /auth/permissions)
  adsActiveBusiness: 'adsActiveBusiness', // {id, name} DN đang chọn, gửi qua X-Business-Id
};


export const STORAGE_SETTING_UI = {
  posWrapperHorizontal: 'pos_wrapper_horizontal'
}
